// src/components/ProtectedRoute/Admin/Consoles/Pages/ScientificNamesConsole.jsx
import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import AddIcon from "@mui/icons-material/Add";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import scientificNamesPlugin from "./scientificNames.plugin";
import DialogScientificNameEditor from "../../Dialogs/DialogScientificNameEditor";
import DialogGbifBulkImport from "../../Dialogs/DialogGbifBulkImport";
import DialogGbifBulkImportV2 from "../../Dialogs/DialogGbifBulkImportV2";
import DialogGbifHierarchicalImport from "../../Dialogs/DialogGbifHierarchicalImport/DialogGbifHierarchicalImport";
import DialogScientificNameDocs from "../../Dialogs/DialogScientificNameDocs";

export default function ScientificNamesConsole() {
  const [gbifOpen, setGbifOpen] = useState(false);
  const [gbifV2Open, setGbifV2Open] = useState(false);
  const [gbifV3Open, setGbifV3Open] = useState(false);
  const [docsRow, setDocsRow] = useState(null);

  return (
    <>
      <ConsolePageFrame
        title="Scientific Name Data"
        plugin={scientificNamesPlugin}
        searchPlaceholder="Search (name / author / fields...)"
        columnsBuilder={({ onEdit }) => scientificNamesPlugin.columns({ onEdit, onEditDocs: setDocsRow })}
        renderAddDialog={({ onClose }) => (
          <DialogScientificNameEditor open mode="add" onClose={onClose} />
        )}
        renderEditDialog={({ row, onClose }) => (
          <DialogScientificNameEditor open mode="edit" scientificName={row} onClose={onClose} />
        )}
        headerExtras={({ openAdd }) => (
          <>
            <Tooltip title="Automatically add names via GBIF service">
              <IconButton color="primary" onClick={() => setGbifOpen(true)}>
                <PublicIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Prototype: GBIF (v2)">
              <IconButton color="primary" onClick={() => setGbifV2Open(true)}>
                <NewReleasesIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Prototype: GBIF Hierarchical (v3)">
              <IconButton color="secondary" onClick={() => setGbifV3Open(true)}>
                <NewReleasesIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Manually add names">
              <IconButton color="primary" onClick={openAdd}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
        addButtonProps={{ sx: { display: "none" } }}
        toastMessages={{ create: "Scientific name created", update: "Scientific name updated" }}
        initialPageSize={100}
        getRowId={(row) => row.id}
      />
      {gbifOpen && (
        <DialogGbifBulkImport
          open
          onClose={(didUpdate) => {
            // 保存後も作業を継続できるよう、didUpdate時は閉じずに残す
            if (didUpdate) {
              setGbifOpen(true);
              return;
            }
            setGbifOpen(false);
          }}
        />
      )}
      {gbifV2Open && (
        <DialogGbifBulkImportV2
          open
          onClose={(didUpdate) => {
            if (didUpdate) {
              setGbifV2Open(true);
              return;
            }
            setGbifV2Open(false);
          }}
        />
      )}
      {gbifV3Open && (
        <DialogGbifHierarchicalImport
          open
          onClose={() => setGbifV3Open(false)}
        />
      )}
      {docsRow && (
        <DialogScientificNameDocs
          open
          scientificName={docsRow}
          onClose={() => setDocsRow(null)}
        />
      )}
    </>
  );
}
